import {Flow} from "../../../../lib/src/api/repositories/flows-repository";
import {FC, useState} from "react";
import {Button} from "../../../../lib/src/components/form/Button";
import {TriggerEditor} from "./FlowEditor/TriggerEditor";
import {ConditionsEditor} from "./FlowEditor/ConditionsEditor";
import {ActionsEditor} from "./FlowEditor/ActionsEditor";
import {useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {config} from "../../config";
import {Loading} from "../../../../lib/src/components/Loading";
import './FlowEditor/floweditor.css'
export const FlowEditor: FC<{isLoading: boolean, flow: Flow, reload: () => void}> = props => {
  const {learn, flows} = useApiCall(config)
  const learnModules = useApiEndpoint(() => learn.listModules())
  const [trigger, setTrigger] = useState(props.flow.trigger)
  const [conditions, setConditions] = useState(props.flow.conditions)
  const [actions, setActions] = useState(props.flow.actions)
  const [dirty, setDirty] = useState(false)

  const save = async () => {
    await flows.updateFlowLogic(props.flow.id, trigger, conditions, actions)
    props.reload()
  }
  const cancel = async () => {
    setTrigger(props.flow.trigger)
    setConditions(props.flow.conditions)
    setActions(props.flow.actions)
    setDirty(false)
  }

  return <div className={'py-4 rounded-lg bg-white bg-graph-paper border-2 border-slate-100'}>
    <div className={'grid grid-cols-3'}>
      <div>
        <div className={'h-12 flex items-center'}>
          <div className={'border-t-2 border-brand-primary w-4'}></div>
          <div className={'flex flex-col items-center h-full mr-2'}>
            <div className={'flex-1'}></div>
            <div className={'w-4 h-4 rounded-full bg-brand-primary'}></div>
            <div className={'border-r-2 border-brand-primary-container flex-1'}></div>
          </div>
          <h2 className={'font-bold text-lg'}>Trigger</h2>
          <div className={'border-t-2 border-brand-primary flex-1 ml-2'}></div>
        </div>
        <TriggerEditor trigger={trigger} setTrigger={(s) => {
          setDirty(true)
          setTrigger(s)
        }}/>
      </div>
      <div>
        <div className={'h-12 flex items-center'}>
          <div className={'border-t-2 border-brand-primary w-4'}></div>
          <div className={'flex flex-col items-center h-full mr-2'}>
            <div className={'flex-1'}></div>
            <div className={'w-4 h-4 rounded-full bg-brand-primary'}></div>
            <div className={'border-r-2 border-brand-primary-container flex-1'}></div>
          </div>
          <h2 className={'font-bold text-lg'}>Voorwaarden</h2>
          <div className={'border-t-2 border-brand-primary flex-1 ml-2'}></div>
        </div>
        <ConditionsEditor trigger={trigger} conditions={conditions} setConditions={(s) => {
          setDirty(true)
          setConditions(s)
        }} />
      </div>
      <div>
        <div className={'h-12 flex items-center'}>
          <div className={'border-t-2 border-brand-primary w-4'}></div>
          <div className={'flex flex-col items-center h-full mr-2'}>
            <div className={'flex-1'}></div>
            <div className={'w-4 h-4 rounded-full bg-brand-primary'}></div>
            <div className={'border-r-2 border-brand-primary-container flex-1'}></div>
          </div>
          <h2 className={'font-bold text-lg'}>Acties</h2>
          <div className={'border-t-2 border-brand-primary flex-1 ml-2'}></div>
        </div>
        <Loading loading={learnModules.isLoading}>
          <ActionsEditor trigger={trigger} actions={actions} setActions={(s) => {
            setDirty(true)
            setActions(s)
          }} learnModules={learnModules?.resource ?? []} />
        </Loading>
      </div>
    </div>
    {dirty && <div className={'px-4 pt-4 mt-4 border-t border-slate-200 bg-white -mb-4 pb-4 rounded-b-lg flex items-center space-x-2'}>
      <Button type={'primary'} size={'sm'} text={'Wijzigingen opslaan'} onClick={save} />
      <Button type={'secondary'} size={'sm'} text={'Annuleren'} onClick={cancel} />
    </div>}
  </div>
}
